import { render, staticRenderFns } from "./VATRecoverabilityTable.vue?vue&type=template&id=4053066c&scoped=true"
import script from "./VATRecoverabilityTable.vue?vue&type=script&lang=ts"
export * from "./VATRecoverabilityTable.vue?vue&type=script&lang=ts"
import style0 from "./VATRecoverabilityTable.vue?vue&type=style&index=0&id=4053066c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053066c",
  null
  
)

export default component.exports